const isApProductInStorage = (products) => {
      if(!Array.isArray(products)){
        return false
      }
      return products.some(item => item.product_name == "Accidentes Personales") 
}

export { isApProductInStorage }